import * as ko from 'knockout';

import { session } from '../session';

ko.bindingHandlers['tenantHref'] = {
  update: (element: Element, valueAccessor: () => KnockoutObservable<string>) => {
    element.setAttribute('href', session.toTenantPath(ko.unwrap(valueAccessor())));
  },
};
